<template>
  <div class="reader_container">
    <!--  :class="[theme, fontSize]" -->

    <div class="reader_content">
      <van-pull-refresh
          v-model="refreshing"
          :loosing-text="$t('release_to_refresh')"
          :loading-text="$t('loading')"
          @refresh="onRefresh"
      >
        <van-list
            v-if="data.chaptersDetailsList.length"
            v-model:loading="loading"
            :finished="finished"
            :finished-text="$t('all_loaded')"
            :loading-text="$t('loading')"
            :immediate-check="false"
            class="content-box"
            :offset="1200"
            @load="loadMore2"
        >
          <ClientOnly>
            <div
                class="chapter"
                v-for="item in data.chaptersDetailsList"
                :id="item.chapter_id"
                :key="item.chapter_id"
            >
              <div class="title">{{ item.title }}</div>
              <div class="content" v-html="item.content"></div>
            </div>
            <!--  解锁卡片 :theme="theme" -->
            <UnlockCard
                ref="unlockCard"
                @handleShowProductPopup="showProductPopup"
                @unlockChapter="unlockChapter"
                :isAds="true"
                :coin-tier-shown="data.coinTierShown"
            ></UnlockCard>
          </ClientOnly>
        </van-list>
        <div ref="footObj" :class="{footObjChangeDisplay: data.displayObjVisible}"
             style="height: 50px;width: 50px;"></div>
      </van-pull-refresh>
    </div>

    <!--  商品列表  -->
    <ClientOnly>
      <ProductsPopup
          ref="productsPopup"
          @openPayPopup="openPayPopup"
          @handleClose="handleClose"
          @coinTierTriggered="data.coinTierShown = true"
          :unlockCoin="data.unlockCoin"
          :show-coins="data.coinTierShown"
      ></ProductsPopup>
      <!--  登录弹窗  -->
      <LoginPopup @updateUserInfo="data.isLogin = true"></LoginPopup>
      <!--  添加到FB或者添加到桌面指引弹窗  -->
      <AddToFacebook :type="data.guideType"></AddToFacebook>
      <!--  统一的弹窗处理组件  -->
      <PopupHandle
          ref="popupHandle"
          :type="data.popupType"
          :extra="createExtra()"
          @close="close"
      ></PopupHandle>
      <!--  全屏遮罩  -->
      <FullScreenMask :showMask="data.showMask" :background="'rgba(0,0,0,0.4)'">
        <!-- 自定义内容：例如居中弹窗 -->
        <van-loading type="spinner" color="#ffffff"/>
      </FullScreenMask>
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
import eventBus from "../../utils/eventBus";

definePageMeta({
  layout: false
})
import AddToFacebook from '~/components/addToFB/index.vue'
import {showToast} from 'vant'
import {onMounted, reactive, ref} from 'vue'
import {useRoute} from 'vue-router'
import {useI18n} from 'vue-i18n'
import {useOrderConfirm} from '../../composables/useOrderConfirm'
import {useUserBalanceStore} from '~/stores/userBalance'
import {useLandDataStore} from "../../stores/land";
import {clientFetch} from "../../utils/clientFetch";
const landDataStore = useLandDataStore()
const userBalance = useUserBalanceStore()
// 使用共享状态
const clientInfo = useState('clientInfo')
console.log('使用共享状态', clientInfo)
const {captureOrder} = usePay()
const {checkAndHandleOrder} = useOrderConfirm()
const {t} = useI18n()
const route = useRoute()
const router = useRouter()
const {getUserInfo} = useUserInfo()
const productsPopup = ref<any | null>(null)
const finished = ref(false)
const loading = ref(false)
const refreshing = ref(false)
const unlockCard = ref<any | null>(null)
const popupHandle = ref<any | null>(null)
const data: KeyMap = reactive({
  coinTierShown: false, // V2.3.0 金币档位条：浮层/挽留关闭且未创建订单后置 true，进页默认 false
  guideType: 'fb',
  chapterInfo: {},
  chapterId: '',
  chaptersDetailsList: [],
  prevChapterId: 0,
  nextChapterId: 0,
  currentOrder: '',
  isLogin: false,
  showMask: false,
  isAutoUnlock: false,
  autoUnlockProcessing: false, // 防止重复自动解锁
  isWaitingUnlock: false, // 是否有章节等待解锁，用于控制上拉加载
  isNeedUnlock: false, // 当前获取的章节是否需要解锁
  currentChapter: {}, // 当前章节
  popupQueueCount: 0,
  displayVisible: false, // 文章底部监听对象状态
  displayObjVisible: false,
  uiMore: false, // UI框架下拉列表触发状态
  errorCount: 0, // 错误重试次数,
  unlockCoin: 0
})

const popupQueue = ref<any[]>([]) // 弹窗队列
const currentPopup = ref<any | null>(null) // 当前正在显示的弹窗

watch(
    popupHandle,
    async (val) => {
      if (!val) return
      requestIdleCallback(async () => {
        try {
          const localOrderNo = localStorage.getItem('order_no')
          const orderNo = route.query.order_no as string
          const paymentType = route.query.payment_type as string
          // 如果本地订单号和当前订单号相同，直接返回
          if (!orderNo || (localOrderNo && localOrderNo === orderNo)) return
          data.showMask = true
          // 如果是支付类型为 order，需要先捕获订单
          if (paymentType === 'order') {
            await captureOrder()
          }
          // 获取订单状态
          await getOrderStatus()
        } catch (err) {
          console.error('watch popupHandle 异步处理失败:', err)
        }
      })
    },
    {immediate: true}
)

// 文章底部监听
watch(
    () => data.displayVisible,
    (newVal) => {
      if (!data.uiMore && newVal) {
        loadMore();
        data.displayObjVisible = true;
        setTimeout(() => {
          data.displayObjVisible = false;
        }, 1000)
      }

    }
)

const createExtra = () => {
  return {
    pay_entry: 'reading_page',
    book_id: data.book_id,
    chapter_id: data.chapterId
  }
}

// 关闭挽留弹窗事件
const close = () => {
  showNextPopup()
}

// 显示下一个弹窗
const showNextPopup = async () => {
  if (popupQueue.value.length === 0) {
    console.log('🎉 所有挽留弹窗展示完毕')
    currentPopup.value = null
    return
  }

  currentPopup.value = popupQueue.value.shift()
  console.log(currentPopup.value)
  await nextTick()
  popupHandle.value?.open(currentPopup.value.type, currentPopup.value.value)
}

const handleClose = (extraData: any[]) => {
  console.log('弹窗队列', extraData)
  popupQueue.value = extraData
  data.popupQueueCount = popupQueue.value.length
  // 弹窗唤起顺序 SpecialOffer > RechargePopup
  showNextPopup()
}

// 打开支付弹窗
const openPayPopup = (info: { type: any; product: any }) => {
  console.log('当前商品:', info)
  data.paymentType = info.type
  data.currentProduct = info.product
  const extraData = {...data.currentProduct}
  console.log('extraData', extraData)
  popupHandle.value?.open('PayPopup', extraData)
}

// 打开商品弹窗
const showProductPopup = () => {
  productsPopup.value?.open()
}

const getOrderStatus = async () => {
  // 开始获取订单状态就展示loading
  try {
    const res = await checkAndHandleOrder()
    console.log('支付结果及弹窗类型', res)
    if (res.action === 'none') return
    data.popupType = res.action
    console.log('data.popupType', data.popupType)
    console.log('popupHandle.value', popupHandle.value)
    let extraData = {...res.extraData}
    popupHandle.value?.open(data.popupType, extraData)
    // 如果是两种支付成功的弹窗，如果状态是1就重新拉取一下章节列表
    if (res.action === 'CoinsBuySuccess' || res.action === 'PayVipSuccess') {
      console.log('支付成功了')
      //   更新一下用户信息
      await getUserInfo()
      //   更新一下钱包余额
      userBalance.refreshBalance()
    }
  } catch (e) {
    console.log(e)
  } finally {
    // 获取订单状态结束就关闭loading
    data.showMask = false
  }
}

// 阅读事件上报
const reportReadingEvent = async (chapterId?: any) => {
  const body = {
    book_id: data.book_id,
    chapter_id: chapterId ? chapterId : data.chapterId
  }
  try {
    const res = await useClientFetch('/api/reader/send-read-event', {
      method: 'POST',
      body,
      key: Date.now().toString()
    })
    const realData = res.data.value
    if (realData.code === 0) {
      console.log('上报成功')
    }
  } catch (e) {
    console.log('阅读事件上报:', e)
  } finally {
    cacheReportEventQueue(body)
  }
}

// 获取登录状态
const getIsLogin = async () => {
  const login_info = localStorage.getItem('login_info')
  if (login_info) {
    const loginInfo = JSON.parse(login_info)
    data.isLogin =
        loginInfo.is_third_party_bound && loginInfo.is_third_party_bound === 1
  }
  console.log('当前是否是三方登录状态', data.isLogin)
}

// ==================重构部分逻辑==================
// （1）首屏获取内容方法
const getFirstScreenData = async (chapterId: number) => {
  const query = {chapter_id: chapterId}
  try {
    loading.value = true
    const res = await useClientFetch('/api/reader/get-chapter-details', {
      query
    })
    const realData = res.data.value

    if (realData.code === 0) {
      const chapter = realData.data
      console.log('chapter', chapter)
      chapter.content = chapter.content.replace(/\r\n/g, '</p><p>')
      chapter.content = chapter.content.replace(/\n\n/g, '</p><p>')
      chapter.content = chapter.content.replace(/\n/g, '</p><p>')
      chapter.content = `<p>${chapter.content}</p>`

      // 首屏内容直接push
      data.chaptersDetailsList.push(chapter)

      // 更新章节定位
      data.chapterId = chapter.chapter_id // 当前章节ID
      data.nextChapterId = chapter.next_chapter_id // 下一章ID
      // data.prevChapterId = chapter.prev_chapter_id // 上一章ID
      data.currentOrder = chapter.chapter_order // 当前章节序号
      data.isNeedUnlock = realData.data.unlock_status === 2 // 当前章节是否需要解锁
      data.currentChapter = chapter
      data.errorCount = 0
      // // 首屏上报阅读事件
    } else {
      data.errorCount += 1;
    }
  } catch (e) {
    console.error(e)
  } finally {
    loading.value = false
  }
}

const loadMore2 = () => {
  data.uiMore = true
  loadMore();
}
// (2)上拉加载获取内容
const loadMore = async () => {
  // 如果没有下一章，标记为 finished，直接返回
  if (data.nextChapterId === 0 || data.errorCount > 10) {
    finished.value = true
    loading.value = false
    return
  }
  // 正常加载下一章
  await getChapterDetailHandler(data.nextChapterId)
}

// (3) 下拉获取内容的处理器
const getChapterDetailHandler = async (chapterId: number, scrollTo = false) => {
  if (!chapterId || chapterId === 0) return

  // 如果有章节正在等待解锁。就不要继续获取了
  if (data.isWaitingUnlock) {
    // 重置loading状态
    loading.value = false
    return false
  }

  // 每次获取章节内容，不管需不需解锁，都要去获取，然后视情况弹出解锁卡片
  await getChapterDetail(chapterId, scrollTo)
  console.log('看一下是否需要解锁', data.isNeedUnlock)
  // 获取到章节内容了判断一下是否需要解锁
  if (data.isNeedUnlock) {
    // 遇到了需要解锁的章节，更新一下isWaitingUnlock，解锁完一章要重置回去
    data.isWaitingUnlock = true
    //   如果需要解锁，则尝试自动解锁
    if (data.isAutoUnlock) {
      await unLock()
    } else {
      // 否则弹出手动解锁弹窗,传入当前章节信息用于解锁
      unlockCard.value?.showUnLockCard(data.currentChapter)
      // 获取解锁需要的金币
      data.unlockCoin = data.currentChapter.unlock_coin
      // 重置列表loading状态
      loading.value = false
      return false
    }
  } else {
    unlockCard.value?.hideUnLockCard()
    //   如果是不需要解锁的章节，上报一下阅读事件
    await reportReadingEvent()
  }
}

// (4)真正的非首屏获取章节数据的方法，使用$fetch避免缓存
const getChapterDetail = async (
    chapterId: number,
    scrollTo: boolean = false
) => {
  const query = {chapter_id: chapterId}
  try {
    loading.value = true
    const res = await clientFetch('/api/reader/get-chapter-details', {query})
    console.log(`获取章节ID为${chapterId}的章节详情`, res)
    if (res.code === 0) {
      const chapter = res.data
      // 格式化换行符
      chapter.content = chapter.content.replace(/\r\n/g, '</p><p>')
      chapter.content = chapter.content.replace(/\n\n/g, '</p><p>')
      chapter.content = chapter.content.replace(/\n/g, '</p><p>')
      chapter.content = `<p>${chapter.content}</p>`

      // 放入数组
      appendData(chapter)

      // 更新章节定位
      data.chapterId = chapter.chapter_id // 当前章节ID
      data.nextChapterId = chapter.next_chapter_id // 下一章ID
      // data.prevChapterId = chapter.prev_chapter_id // 上一章ID
      data.currentOrder = chapter.chapter_order // 当前章节序号
      data.isNeedUnlock = res.data.unlock_status === 2 // 当前章节是否需要解锁
      data.currentChapter = chapter
      data.errorCount = 0
      localStorage.setItem('current_chapter_id', data.chapterId)
      if (chapter.prev_chapter_id < data.prevChapterId) {
        data.prevChapterId = chapter.prev_chapter_id
      }
      // 没有下一章时标记 finished
      if (data.nextChapterId === 0) {
        finished.value = true
      }
    } else {
      data.errorCount += 1
    }
    if (data.errorCount > 10) {
      finished.value = true
    }
  } catch (e) {
    console.error(e)
  } finally {
    loading.value = false
  }
}

// (5)处理把章节内容放入数组的方法，去重+排序
const appendData = (newItem: any) => {
  if (!newItem || newItem.chapter_order == null) return

  // 1. 将旧数据放入 Map（以 chapter_order 为唯一键）
  const uniqueMap = new Map<number, any>()
  data.chaptersDetailsList.forEach((item: { chapter_order: number }) => {
    uniqueMap.set(item.chapter_order, item)
  })

  uniqueMap.set(newItem.chapter_order, newItem)

  // 3. 重新生成排序后的数组
  data.chaptersDetailsList = Array.from(uniqueMap.values()).sort(
      (a, b) => a.chapter_order - b.chapter_order
  )
}

// (6)解锁卡片通知解锁
const unlockChapter = async (chapterId: number) => {
  console.log('解锁章节ID', chapterId)
  // 当前章节解锁成功后重置等待解锁状态
  data.isWaitingUnlock = false
  // 隐藏解锁卡片
  unlockCard.value?.hideUnLockCard()
  // // 获取当前章节的正式内容
  // await getChapterDetail(chapterId, false)
  // 跳转到阅读页
  router.push({
    path: '/reader',
    query: {
      id: data.book_id,
      chapter_id: chapterId,
      from: 'ads'
    }
  })
}

// (7)上拉加载上一章
const onRefresh = async () => {
  // 每次上拉先重置一下待解锁状态
  data.isWaitingUnlock = false
  // 重置一下加载完毕状态
  finished.value = false
  if (data.prevChapterId === 0) {
    showToast(t('reader.already_first'))
    refreshing.value = false
    return
  }
  console.log('==========================', data.prevChapterId)
  // data.chaptersDetailsList = []
  await getChapterDetailHandler(data.prevChapterId)
  refreshing.value = false
}

// (9)获取自动解锁状态
const getAutoUnlockStatus = async () => {
  const isAutoUnlock = localStorage.getItem('auto_unlock')
  if (isAutoUnlock) {
    data.isAutoUnlock = isAutoUnlock === '1'
  } else {
    data.isAutoUnlock = false
    // 如果没有获取到，默认设置一下关闭
    localStorage.setItem('auto_unlock', '0')
  }
}

// (10) 解锁方法
const unLock = async () => {
  data.isWaitingUnlock = true
  // 金币充足直接解锁
  const body = {
    chapter_id: data.chapterId
  }
  try {
    const res = await clientFetch('/api/reader/unlock-chapter', {
      method: 'POST',
      body
    })
    console.log('解锁章节', res)
    if (res && res.code === 0) {
      // 获取一下解锁章节的内容
      await getChapterDetail(data.chapterId)
      //   解锁完成调用一下用户信息接口更新一下钱包余额
      userBalance.refreshBalance()
      //   解锁成功更新一下待解锁状态
      data.isWaitingUnlock = false
    } else if (res.code === 4006) {
      //   余额不足
      showToast(res.msg)
      // 弹出手动解锁弹框
      unlockCard.value?.showUnLockCard(data.currentChapter)
      // 获取解锁需要的金币
      data.unlockCoin = data.currentChapter.unlock_coin
    } else {
      showToast(res.msg || t('reader.unlock_fail'))
      //   弹出解锁弹框
      unlockCard.value?.showUnLockCard(data.currentChapter)
      // 获取解锁需要的金币
      data.unlockCoin = data.currentChapter.unlock_coin
    }
  } catch (e) {
    console.log('章节解锁', e)
  }
}

// (11) 缓存上报事件队列
const cacheReportEventQueue = async (item: any) => {
  if (process.server) {
    return
  }
  const eventQueue = localStorage.getItem('report_event_queue')
  if (eventQueue) {
    const queue = JSON.parse(eventQueue)
    queue.push(item)
  } else {
    const queue = [item]
    localStorage.setItem('report_event_queue', JSON.stringify(queue))
  }
}

// (12) 清空上报事件队列
const clearReportEventQueue = async () => {
  const eventQueue = localStorage.getItem('report_event_queue')
  if (!eventQueue) return

  let queue = JSON.parse(eventQueue)
  if (!Array.isArray(queue) || queue.length === 0) return

  const successIds: any[] = []

  for (const item of queue) {
    try {
      const res = await useClientFetch('/api/reader/send-read-event', {
        method: 'POST',
        body: item
      })

      const realData = res.data.value
      if (realData?.code === 0) {
        console.log('上报成功:', item.chapter_id)
        successIds.push(item.chapter_id)
      } else {
        console.warn('上报失败:', realData)
      }
    } catch (e) {
      console.error('阅读事件上报错误:', e)
    }
  }

  // 过滤未成功的项
  queue = queue.filter((q) => !successIds.includes(q.chapter_id))
  localStorage.setItem('report_event_queue', JSON.stringify(queue))
}

// 获取落地页数据
const getLandPageData = async () => {
  // 使用 useRoute 构建完整 URL
  const route = useRoute()
  // const origin = useRequestURL().origin
  const url = `${route.fullPath}`
  console.log('获取落地页数据url', url)
  console.log('获取落地页数据fullPath', route.fullPath)
  const body = {
    pro_code: route.params.id,
    url,
  }
  try {
    const res = await useClientFetch('/api/ads/get-land-page-data', {
      method: 'POST',
      body
    })
    const realData = res.data.value
    console.log('realData', realData)
    if (realData.code === 0) {
      data.nextChapterId = realData.next_chapter_id
      // 更新章节定位
      if (route.query.chapter_id) {
        data.chapterId = Number(route.query.chapter_id)
      } else {
        data.chapterId = realData.data.view.chapter.chapter_id
      }
      data.nextChapterId = realData.data.view.chapter.next_chapter_id
      data.currentOrder = realData.data.view.chapter.chapter_order
      data.pixelId = realData.data.pixel_id
      data.book_id = realData.data.bid
      data.pro_channel = realData.data.pro_channel

      // 加载第一章节
      const chapter = realData.data.view.chapter
      console.log('chapter', chapter)
      chapter.content = chapter.content.replace(/\r\n/g, '</p><p>')
      chapter.content = chapter.content.replace(/\n\n/g, '</p><p>')
      chapter.content = chapter.content.replace(/\n/g, '</p><p>')
      chapter.content = `<p>${chapter.content}</p>`

      // 首屏内容直接push
      data.chaptersDetailsList.push(chapter)
      // 更新章节定位
      data.chapterId = chapter.chapter_id // 当前章节ID
      data.nextChapterId = chapter.next_chapter_id // 下一章ID
      data.prevChapterId = chapter.previous_chapter_id // 上一章ID
      data.currentOrder = chapter.chapter_order // 当前章节序号
      data.currentChapter = chapter
      reportReadingEvent(chapter.chapter_id)
      landDataStore.setMonetizationObj(realData.data.monetization)
    }
  } catch (e) {
    console.log(e)
  }
}

await getLandPageData()
// ==================落地页相关结束==================

// ==================初始化方法==================
// 获取首屏章节内容
// await getFirstScreenData(data.nextChapterId)

function waitForElement(id: string, timeout = 3000) {
  return new Promise<HTMLElement>((resolve, reject) => {
    const start = Date.now()
    const timer = setInterval(() => {
      const el = document.getElementById(id)
      if (el) {
        clearInterval(timer)
        resolve(el)
      } else if (Date.now() - start > timeout) {
        clearInterval(timer)
        reject('element not found')
      }
    }, 50)
  })
}

// 刷新页面后自动滚动到刷新前的章节
const refreshPage = async () => {
  const currentPageData = localStorage.getItem('current_chapter_id')
  if (!currentPageData) return
  await getChapterDetailHandler(currentPageData)
  // 滚动到该章节锚点

  const el = document.getElementById(currentPageData)
  el?.scrollIntoView({
    behavior: 'smooth', // 平滑滚动
    block: 'start'      // 顶部对齐
  })
  //只保留最后一章
  data.chaptersDetailsList = data.chaptersDetailsList.slice(-1)
  console.log('data.chaptersDetailsList', data.chaptersDetailsList)
}

const footObj = ref(null)
let footObserver = null


onMounted(async () => {
  await landReportEvent({
    pro_channel: data.pro_channel || 'facebook',
    pixel_id: data.pixelId || '',
    book_id: data.book_id || '',
    chapter_id: data.chapterId || '',
    chapter_order: data.currentOrder || ''
  })

  const reported = ref(false)
  const el = await waitForElement(data.chapterId)
  let observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !reported.value) {
            reported.value = true
            // ✅ 上报事件
            reportReadingEvent()
            // 只触发一次
            observer.unobserve(entry.target)
            observer.disconnect()
          }
        })
      },
      {
        threshold: 0.01
      }
  )
  observer.observe(el)
  requestIdleCallback(async () => {
    getIsLogin() // 获取登录状态
    // 保存页面状态信息
    eventBus.on('savePageData' as any, () => {
      localStorage.setItem(
          'currentPageData',
          JSON.stringify({
            order: data.currentOrder,
            chapterId: data.chapterId,
            scrollTop: window.scrollY
          })
      )
    })

    // 会员购买成功，跳转到阅读页
    eventBus.on('updateChapterList' as any, (chapterId) => {
      console.log('更新章节列表消息')
      router.push({
        path: '/reader',
        query: {
          id: data.book_id,
          chapter_id: chapterId,
          from: 'ads'
        }
      })
    })
    // 监听登录成功事件
    eventBus.on('loginSuccess', () => {
      //   登录成功了去清空阅读事件上报队列
      console.log('登录成功，准备清空阅读事件队列')
      clearReportEventQueue()
    })

    // 关闭挽留弹窗后刷新页面
    // eventBus.on('reload_after_close', () => {
    //   console.log('currentPopup.value', currentPopup.value)
    //   data.popupQueueCount -=1
    //   if(data.popupQueueCount === 0) {
    //     console.log('准备刷新')
    //     // showNextPopup()
    //     window.location.reload()
    //   }
    // })
    //   获取自动解锁状态
    getAutoUnlockStatus()
  })
  // refreshPage()


  // 监听底部元素
  try {
    footObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        data.displayVisible = entry.isIntersecting
      })
    }, {
      threshold: 0.1,
      rootMargin: '0px'
    })
    if (footObj.value) {
      footObserver.observe(footObj.value)
    }
  } catch (error) {
  }
  //   将monetization保存到本地存储中
  localStorage.setItem('monetization', JSON.stringify(landDataStore.monetizationObj))
})
</script>

<style scoped lang="scss">
@import '~/assets/styles/theme.scss';

.reader_container {
  width: 100vw;
  height: 100vh;
  background: #f6f6f6;
  position: relative;

  .reader_header {
    width: 100%;
    padding: 12px 17px 12px 21px;
    display: flex;
    align-items: center; /* 补上 */
    justify-content: space-between;
    position: sticky;
    top: 0;
    z-index: 2;
    color: var(--text-color);
    background-color: var(--bg-color);
    transition: all 0.3s ease;

    .menu_content {
      width: 100%;
      padding: 10px 33px 21px 33px;
      position: absolute;
      top: 52px;
      left: 0;
      border-radius: 0 0 17px 17px;
      box-shadow: 0 13px 20px 0 rgba(0, 0, 0, 0.1);
      display: flex;
      justify-content: space-between;
      color: var(--text-color);
      background-color: var(--bg-color);
      transition: all 0.3s ease;

      .menu_content_item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 7px;

        span {
          font-family: 'SFPro', 'SFPro';
          font-weight: 400;
          font-size: 14px;
          line-height: 16px;
        }

        img {
          width: 47px;
          height: 47px;
        }
      }
    }
  }

  .reader_content {
    width: 100%;
    height: calc(100% - 12px);
    color: var(--text-color);
    font-size: 18px;
    background-color: var(--bg-color);
    //padding: 23px;
    transition: all 0.3s ease;
    overflow-y: auto;

    .title {
      font-family: 'Poppins';
      font-weight: 500;
      line-height: 26px;
      text-align: left;
      color: var(--text-color) !important;
      font-size: calc(var(--font-size) + 6px) !important;
      transition: all 0.3s ease;
    }

    .content {
      margin-top: 18px;
      font-family: 'Poppins';
      font-weight: 400;
      line-height: 32px;
      color: var(--text-color);
      font-size: var(--font-size);
      text-align: left;
      transition: all 0.3s ease;
      user-select: none;

      > p {
        margin-top: 24px;
      }
    }

    .chapter {
      background-color: var(--bg-color);
      color: var(--text-color);
      font-size: var(--font-size);
      padding: 21px;

      &:first-child {
        .title {
          display: none;
        }

        .content {
          margin-top: 0;
        }
      }
    }

    .van-cell__value {
      text-align: left;
    }
  }

  .reader_header_left {
    display: flex;
    align-items: center;
    gap: 6px;
    flex: 1 1 auto; /* 左侧占满剩余空间 */
    min-width: 0; /* 关键：允许这一列收缩 */
    img {
      width: 15px;
      height: 15px;
      flex: 0 0 auto;
    }

    p {
      flex: 1 1 auto; /* 关键：让标题占剩余并可收缩 */
      min-width: 0; /* 关键：否则内容宽度不允许被压缩 */
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .reader_header_right {
    display: flex;
    align-items: center;
    gap: 17px;
    flex: 0 0 auto; /* 右侧不挤占左侧 */
    img {
      width: 29px;
      height: 29px;
    }
  }

  .menu_bottom_overlay {
    width: 100%;
    height: 100vh;
    position: absolute;
    background: rgba(0, 0, 0, 0.3);
    top: 0;
    left: 0;
    z-index: 1;

    .menu_bottom {
      padding: 26px 19px 21px 19px;
      width: 100%;
      font-family: 'SFPro', 'SFPro';
      font-weight: 400;
      font-size: 18px;
      color: #222222;
      line-height: 28px;
      text-align: left;
      font-style: normal;
      position: fixed;
      bottom: 0;
      box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);
      border-radius: 17px 17px 0 0;
      background: var(--bg-color);

      .font_size_set {
        display: flex;
        justify-content: space-between;
        gap: 14px;

        .setting_item {
          background: var(--chapter-btn-bg);
          border-radius: 18px;
          width: calc((100% - 14px) / 2);
          color: var(--chapter-btn-text-color) !important;

          &:nth-child(1) {
            padding: 7px 0;
            display: flex;
            justify-content: center;
            align-items: center;

            img {
              width: 21px;
              height: 21px;

              &:first-child {
                margin-right: 32px;
              }

              &:last-child {
                margin-left: 32px;
              }
            }
          }

          &:nth-child(2) {
            padding: 9px 0px;
            font-family: 'SFPro', 'SFPro';
            font-weight: 400;
            font-size: 15px;
            color: #32343a;
            line-height: 18px;
            text-align: center;
            font-style: normal;
          }

          .divider_line {
            width: 1px;
            height: 17px;
            border: 1px solid #e4e4e4;
          }
        }
      }

      .theme_set {
        display: flex;
        justify-content: space-between;
        gap: 14px;
        margin-top: 26px;

        .theme_set_item {
          flex: 1;
          border-radius: 18px;
          text-align: center;
          padding: 5px 0;
          outline: 1px solid transparent;

          &:first-child {
            background: #ffffff;
          }

          &:nth-child(2) {
            background: #efddbe;
          }

          &:nth-child(3) {
            background: #cdddc4;
          }

          &:last-child {
            background: #111111;
            color: #d1d1d1;
          }
        }

        .active {
          outline: 1px solid #ff1979;
        }
      }

      .chapter_jump {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 14px;
        margin-top: 26px;

        .chapter_jump_item {
          height: 35px;
          background: var(--chapter-btn-bg);
          border-radius: 18px;
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: 'SFPro', 'SFPro';
          font-weight: 400;
          font-size: 15px;
          color: var(--chapter-btn-text-color);
          line-height: 18px;
          text-align: center;
          font-style: normal;
          gap: 7px;

          img {
            width: 15px;

            &:last-child {
              transform: rotate(180deg);
            }
          }
        }
      }
    }
  }

  .chapter_select_overlay {
    width: 100%;
    height: 100vh;
    position: absolute;
    background: rgba(0, 0, 0, 0.6);
    top: 0;
    left: 0;
    z-index: 3;

    .chapter_select {
      width: 85%;
      height: 100%;
      display: flex;
      flex-direction: column;
      color: var(--text-color);
      background-color: var(--bg-color);
      position: relative;

      .book_info {
        width: 100%;
        padding: 17px;
        display: flex;
        gap: 12px;

        img {
          width: 59px;
          height: 78px;
          border-radius: 6px;
          box-shadow: 0px 2 4px 0px rgba(0, 0, 0, 0.2);
        }

        .book_info_right {
          display: flex;
          flex-direction: column;
          gap: 12px;
          /* NEW: 允许在 flex 行内正确收缩 */
          flex: 1 1 auto;
          min-width: 0;

          p {
            color: var(--chapter-info-title-color);
            font-size: 18px;
            font-style: normal;
            font-weight: 500;
            line-height: 21px;

            /* 关键点：宽度约束 + 可换行 */
            width: 100%;
            white-space: normal;
            word-break: break-word; /* 防长单词/连续字符 */
            overflow-wrap: anywhere;

            /* 多行省略核心 */
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;

            /* 某些 WebKit 需高度参与计算，更稳 */
            max-height: calc(2 * 21px);
          }

          span {
            font-family: 'SFPro', 'SFPro';
            font-weight: 400;
            font-size: 12px;
            color: #858c99;
            line-height: 15px;
            text-align: left;
            font-style: normal;
          }
        }
      }
    }

    .chapter_list {
      width: 100%;
      flex: 1;
      overflow-y: auto;

      .chapter_list_item {
        padding: 14px 17px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        img {
          width: 19px;
          height: 19px;
        }

        p {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 15px;
        }
      }

      .active {
        background: var(--chepter-bg-color);
        color: #ff1979;
      }
    }
  }

  .loading_box {
    padding: 5px;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 5px;
  }

  .footObjChangeDisplay {
    position: fixed;
    left: -1000px;
  }
}
</style>
